import { render, staticRenderFns } from "./DetalheHistoricoInadimplenciaClientesForm.vue?vue&type=template&id=0c0a146c&scoped=true&"
import script from "./DetalheHistoricoInadimplenciaClientesForm.vue?vue&type=script&lang=js&"
export * from "./DetalheHistoricoInadimplenciaClientesForm.vue?vue&type=script&lang=js&"
import style0 from "./DetalheHistoricoInadimplenciaClientesForm.vue?vue&type=style&index=0&id=0c0a146c&scoped=true&lang=css&"
import style1 from "./DetalheHistoricoInadimplenciaClientesForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a146c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
